import { ZipCodeTestIds } from '@ui/business-components/ZipCodeForm/ZipCodeForm'

export const EST_TIME_ZONE = 'America/New_York'

export const TIME_SLOTS_TABLE_DAYS_QUANTITY = 5

export const DATE_FORMAT_WEEK_DAY = 'EEE'

export const DATE_FORMAT_DATE = 'd'

export const DATE_FORMAT_CONFIRMATION = 'MMM d'

export const TIME_FORMAT_CONFIRMATION = 'h:mm a'

export const DATE_FORMAT_CALENDAR = "yyyy-MM-dd'T'HH:mm:ssxxxxx"

export const ERROR_MESSAGES = {
  backgroundRequest: 'Sorry, there’s an error. Please refresh the page.',
  createLead: 'Sorry, there’s an error. Please submit your info again.',
  confirmBooking: 'Sorry, there’s an error. Please try again.'
}

export const ZIP_CODE_FORM_TEST_IDS: Required<ZipCodeTestIds> = {
  form: 'booking-zip-code-form',
  input: 'booking-zip-code-input',
  button: 'booking-zip-code-button'
}

export const PROVIDER_SCREEN_BUTTONS_TITLES = {
  continue: 'continue',
  skip: 'skip'
}
